import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs w-4 h-4 flex items-center justify-center"></i>
              )}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-accent-500 hover:text-accent-600 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700 font-medium whitespace-nowrap" : "whitespace-nowrap"}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: items
              .filter((item) => item.href)
              .map((item, index) => ({
                "@type": "ListItem",
                position: index + 1,
                name: item.label,
                item: `https://xiuxiuse.com${item.href}`,
              })),
          }),
        }}
      />
    </nav>
  );
}